import React, {useEffect} from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import {connect, useSelector} from 'react-redux'

// components
import LabelForm from "./_form";
import LabelFilters from "./_filters";
import LangLabelRow from "./_langRows";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {GenericTableButton } from "../../../components/buttons/buttonsActions";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import TableAdapter from "../../../components/TableAdapter/TableAdapter";

// labels
import { LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";

// actions

// services
import {labelService} from "../../../jwt/_services/configuration/labelService";
import RemoveFormFirebaseButton from "../../../components/buttons/RemoveFromFirebaseButton";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {GenericButton} from "../../../components/buttons/customButtons";
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";

const LabelList = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const {listDomainObjects} = componentState?.data || [];
    const { app, pageSize, pageIndex, totalSize, filter } = componentState?.data || {};

    useEffect( () => {
        if (!props.generalPropouse) {
            if (!app?.fbDataBase?.id)
                return;

            const _filter = {
                onlyRegistered : true,
                fbDataBase : { id : app?.fbDataBase?.id },
                item : {
                }
            };

            props.setFilter(path, _filter);
        } else {
            const _filter = {
                onlyRegistered : false,
                item : {
                }
            };

            props.setFilter(path, _filter);
        }
    }, [ app ]);

    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, labelService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);

    useEffect(() => {

    }, [listDomainObjects]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams(path,  tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({path,  remove : genericIndexedActions.delete , data : data, fbDataBaseId :  app?.fbDataBase?.id, service: labelService } );
    };

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        ModalFormContainer( LabelForm, {path, generalPropouse : props.generalPropouse } )
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);
        ModalFormContainer(LabelForm, {path, data, generalPropouse : props.generalPropouse })
    }


    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------
    const actionsFormatter = (cell, row) => <>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <TranslateButton item={row} service={ labelService } path={path}/>
        <RemoveFormFirebaseButton id={row?.id} fbDataBase={app?.fbDataBase?.id} service={labelService} />
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>

    const expandRow = {
        renderer: row => <LangLabelRow row={row}/>,
        showExpandColumn : true,
        expandByColumnOnly: true,
    };

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            headerStyle: {width: '0px'},
            hidden: true
        }, {
            dataField: 'code',
            text: 'Código'
        }, {
            dataField: 'description',
            text: 'Descripción'
        }, {
            dataField: 'appName',
            text: 'APP',
            hidden: (app.id !== undefined)
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '250px'},
            formatter: actionsFormatter
        }
    ];

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-list-alt mr-2"> </i>{LIST}
                <div className="float-right">
                    <GenericButton
                        style={'table'}
                        label={'Agregar'}
                        toolTip={'Agregar'}
                        icon={'fa-plus'}
                        permission={'add'}
                        onClick={createItem}
                    />
                </div>
            </CardTitle>

            <LabelFilters path={path} generalPropouse={props.generalPropouse} />

            <CardBody className="">
                <TableAdapter
                    striped hover
                    tableHeaderClass='mb-0'
                    remote
                    keyField="id"
                    data={listDomainObjects || []}
                    columns={columns}
                    expandRow={expandRow}
                    noDataIndication={NO_DATA_FOUND}
                    pagination={{pageIndex, pageSize, totalSize}}
                    onTableChange={handleTableChange}
                />
            </CardBody>
        </Card>
    );
}

const mapStateToProps = _ => ({
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(LabelList)